export class Comment{
    public submitterId: number;
    public databaseId: number;
    public projectId: number;
    public firstName: string;
    public lastName: string;
    public organization: string;
    public email: string;
    public address: string;
    public city: string;
    public state: string;
    public zip: string;
    public comment: string;
    public topicIds: number[];
    public sendInfo: boolean;
    public fileURL: string;
    public ocr: boolean;
    public wktPoint: string;
    [key:string]: any;
    constructor(databaseId:number, projectId:number){
        this.submitterId = null;
        this.databaseId = databaseId;
        this.projectId = projectId;
        this.firstName = null;
        this.lastName = null;
        this.organization = null;
        this.email = null;
        this.address = null;
        this.city = null;
        this.state = null;
        this.zip = null;
        this.comment = null;
        this.topicIds =  [];
        this.sendInfo = false;
        this.fileURL = null;
        this.ocr = false;
        this.wktPoint = null;
     }

}


// WEBPACK FOOTER //
// ./src/app/models/comment.ts